import gql from 'graphql-tag';

import integrationThreadFragment from '../fragments/integrationThreadFragment';

export const mutationSetIntegrationThreadIsRead = gql`
  mutation setIntegrationThreadIsRead (
    $integrationID: DokkioID!
    $remoteID: ID!
    $isRead: Boolean!
  ) {
    setIntegrationThreadIsRead (
      integrationID: $integrationID
      remoteID: $remoteID
      isRead: $isRead
    ) {
      ...integrationThreadFragment
    }
  }
  ${integrationThreadFragment}
`;
export default mutationSetIntegrationThreadIsRead;
